module.exports = __webpack_public_path__ + "files/62b0b322b739ff5d57dfe8603b441901.png";